<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel margin-bottom-5"
    *ngIf="userType=='JOB_SEEKER'|| userType=='student'|| userType=='BENCH_RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'|| userType=='FREELANCE_RECRUITER'">
    <app-common-skeleton *ngIf="loadAPIcall"  [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>
    <ng-container *ngIf="filterjob =='false'&&!loadAPIcall|| filterjob == undefined&&!loadAPIcall">
      <div class="panel-heading hbuilt wig-c">
        {{ headerTitle }}
        <span style="float: right;cursor: pointer;" title="Refresh" (click)="refershSugestedjob()"><ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon></span>
      </div>
      <div class="gs-sumo-match">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z"/></svg>
        <span>Sumo AI · Matched to your active candidates</span>
      </div>
      <div class="panel-body padding-top-6 padding-bottom-6 p-0">
        <div class="">
            <ul class="profile-list-1">
              <ng-container *ngIf="suggestionBehavior | async as response">
                <ng-container *ngIf=" response && response?.length > 0">

                <app-common-profile-info *ngFor="let item of response | slice:0:3" [userIdInput]="item.jobPostedBy" [page]="'SUGGJOBS'" [data]="item"
                  [type]="'suggested'" (click)="redirect(item)">
                  <ng-container headline1> {{item.jobTitle}}</ng-container>
                  <div headline2 [title]="item.jobClassification">{{item.jobClassification}} </div>
                  <div headline2 *ngIf="item?.matchingTitles!=null" [title]="item.matchingTitles"> Job
                    title match: <span> {{item.matchingTitles}}</span> </div>
                  <div headline2 *ngIf="item?.matchingPrimarySkils!=null" [title]="item.matchingPrimarySkils">
                    Primary skill match: <span>{{item.matchingPrimarySkils}} </span></div>
                  <div headline2 *ngIf="item?.matchingSecondarySkils!=null" [title]="item.matchingSecondarySkils">
                    Secondary skill match : <span>{{item.matchingSecondarySkils}} </span> </div>

                </app-common-profile-info>

              </ng-container>
              <!-- <p *ngIf="suggestion==null || suggestion?.length==0"> No data Found </p> -->
              <button class="gs-743-more-btn" type="button"
                      *ngIf="response?.length > 0"
                      (click)="modelopen(response,false,'')">
                View more →
              </button>

              <div class="gs-empty" *ngIf="response?.length === 0 || !response">
                <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
                <div class="gs-empty-title">No suggestions yet</div>
                <div class="gs-empty-sub">Create candidates to get suggestions from the platform.</div>
              </div>

               </ng-container>
            </ul>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<div class="margin-bottom-5 eyeicon-scroll-container" *ngIf="viewType=='MAX'"
 infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="2000" (scrolled)="onScrollDown()">
  <div class="panel-body cardw">
    <div class="row">
      <div class="col-12">
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
        <div *ngIf="sugges != null && !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5">
            <app-job-card [viewSize]="'large'" [JobData]="sugges"></app-job-card>
          </div>
        </div>
        <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="(suggestionBehavior | async)?.length == 0 && !loadAPIcall">
          <div class="gs-empty">
            <span class="gs-empty-icon"><ng-icon name="tablerBriefcase"></ng-icon></span>
            <div class="gs-empty-title">No job suggestions yet</div>
            <div class="gs-empty-sub">Sorry, there are no job suggestions for you right now. Check back soon.</div>
          </div>
        </div>
        <div *ngIf="sugges == null && !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5" *ngFor="let item of suggestionBehavior | async">
            <app-job-card [viewSize]="'large'" [JobData]="item" [From]="'SUGGESTED_JOBS'"></app-job-card>
          </div>

          <div class="col-sm-12 gs-end-of-list" *ngIf="stopScroll && (suggestionBehavior | async)?.length > 0" style="text-align: center;padding-top: 1rem;">
            <div class="col-sm-12">
              <!-- <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" >
                <path
                  d="M15.9047 8.38142C16.2952 7.9909 16.9284 7.9909 17.3189 8.38142C17.7094 8.77195 17.7094 9.40511 17.3189 9.79564L12.0541 15.0592C11.079 16.0341 9.49854 16.0354 8.52183 15.062L6.70711 13.2535C6.31658 12.863 6.31658 12.2298 6.70711 11.8393C7.09763 11.4488 7.7308 11.4488 8.12132 11.8393L9.57698 13.2949C9.9675 13.6855 10.6007 13.6855 10.9912 13.2949L15.9047 8.38142Z"
                  fill="#8B5CF6" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 20.9932C7.03321 20.9932 3.00683 16.9668 3.00683 12C3.00683 7.03321 7.03321 3.00683 12 3.00683C16.9668 3.00683 20.9932 7.03321 20.9932 12C20.9932 16.9668 16.9668 20.9932 12 20.9932Z"
                  fill="#8B5CF6" />
              </svg> -->
              <ng-icon name="tablerCircleCheck"></ng-icon>

            </div>
            <div class="col-sm-12">
              <p class="biase">You've reached the bottom of the page</p>
            </div>
          </div>
<!--
          <div *ngIf="(suggestion | async) === null || (suggestion | async)?.length === 0">
            <p appQueryDOM [response]="resultContent" class="empty-message-container"
              style="float: right; position: relative; top: 150%; right: 32rem; bottom: -4rem; font-size: x-large;">
              <img src='assets/images/empty-page-picture.png' alt="">
              <span style="margin-top:-30px;" class="empty-message">fetching Suggestion Job... </span>
            </p>
          </div> -->

        </div>
      </div>

    </div>
  </div>

</div>
